/**
 * DataChart Component
 * Re-export for backwards compatibility
 */

export { default } from './DataChart/index';
export { DataChart } from './DataChart/index';
export type { DataChartProps, DataPoint, ProcessedChartData } from './DataChart/index';
